import { FieldConfig, useField } from 'formik';
import React, { FC } from 'react';
import { Box, Flex } from '@rebass/grid';
import StyledCaret from './StyledCaret';
import ErrorMessage from '@oberoninternal/travelbase-ds/components/form/ErrorMessage';
import { useBirthdateOptions } from '../../hooks/useDetailsFormOptions';
import styled from 'styled-components';
import SelectInput from '@oberoninternal/travelbase-ds/components/form/SelectInput';

type Props = FieldConfig;

const BirthdateField: FC<React.PropsWithChildren<Props>> = props => {
    const [, { error, touched }] = useField(props);
    const { dayOptions, monthOptions, yearOptions } = useBirthdateOptions();

    return (
        <>
            <Birthdate data-error-focus={props.name}>
                <Box flex={6}>
                    <StyledSelectInput
                        small
                        name={`${props.name}.day`}
                        hideChoices
                        ToggleComponent={StyledCaret}
                        placeholder="DD"
                        options={dayOptions}
                        id={`${props.name}.day`}
                        dataCy={`${props.name}.day`}
                        isSearchable
                        thinShadow
                    />
                </Box>
                <Box flex={9}>
                    <StyledSelectInput
                        name={`${props.name}.month`}
                        hideChoices
                        ToggleComponent={StyledCaret}
                        placeholder="MM"
                        options={monthOptions}
                        filterFromStart
                        id={`${props.name}.month`}
                        dataCy={`${props.name}.month`}
                        isSearchable
                        thinShadow
                    />
                </Box>
                <Box flex={6}>
                    <StyledYearSelectInput
                        small
                        name={`${props.name}.year`}
                        hideChoices
                        ToggleComponent={StyledCaret}
                        placeholder="YYYY"
                        options={yearOptions}
                        id={`${props.name}.year`}
                        dataCy={`${props.name}.year`}
                        isSearchable
                        thinShadow
                    />
                </Box>
            </Birthdate>
            {error && touched && typeof error === 'string' && <ErrorMessage>{error}</ErrorMessage>}
        </>
    );
};

const StyledSelectInput = styled(SelectInput)<{ small?: boolean }>`
    min-height: ${({ theme }) => theme.spacing['70_XLarge']};
    boxshadow: 0 0 0 1.5px var(--borderColor);
    /* hack to disable zoom on safari for small devices */
    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.s}) {
        input {
            font-size: 16px !important;
        }
    }

    /* Hide Caret on small smartphones */
    @media screen and (max-width: 374px) {
        padding: 0;
        > div > div:nth-child(2) {
            display: none;
        }
    }
`;

const StyledYearSelectInput = styled(StyledSelectInput)``;

const Birthdate = styled(Flex)`
    ${StyledSelectInput} {
        margin-right: ${({ theme }) => theme.spacing['30_Small']};

        @media screen and (min-width: ${({ theme }) => theme.mediaQueries.m}) {
            margin-right: ${({ theme }) => theme.spacing['40_Standard']};
        }
        &:hover {
            box-shadow: 0 0 0 1.5px var(--borderColor);
        }
    }

    ${StyledYearSelectInput} {
        margin-right: 0;
    }

    max-width: 48rem;
`;

export default BirthdateField;
